export default "__VITE_ASSET__BU6CFdv8__"